export const BelieverStatus = {
    New: 'New',
    Regular: 'Regular',
    Visit: 'Visit'
} 